const de = {
  noItems: 'Derzeit findet in Ihrem Studiengang keine Wahl statt.',
  tabs: {
    selectionInformation: 'Wahlinformationen',
    selectionInformationMobile: 'Übersicht',
    receivedModules: 'Erhaltene Module',
    receivedModulesMobile: 'Erhalten',
    waitingList: 'Warteliste'
  },
  mySelection: 'Meine Wahl',
  numberOfModulesToSelect: 'Wie viele Fächer wollen Sie belegen?',
  myModules: 'Meine Module',
  selectableModules: 'Wählbare Module',
  wishlist: 'Meine Wunschliste',
  modulePrio: 'Module bitte in gewünschter absteigender Priorität angeben.',
  infoBoxModuleSelection:
    'Bitte beachten Sie, dass es sich hier NICHT um eine ModulZUSAGE handelt, sondern um Ihre WUNSCHLISTE.',
  infoBoxModuleSelectionAWPM:
    ' Nach Ende der Wahl erhalten Sie eine E-Mail, welche Module Ihnen aus Ihrer Wunschliste zugeteilt worden sind.',
  signOut: 'Austragen',
  numberOfParticipants: 'Anzahl Teilnehmer',
  positionInWaitingList: 'Position in Warteliste',
  signOutDialogTitle: 'Aus Modul austragen?',
  signOutDialog: 'Wollen Sie sich wirklich aus dem Modul austragen?',
  signInDialog: 'Wollen Sie sich wirklich in dieses Modul eintragen?',
  note: 'Hinweis',
  howManyModules: 'Wie viele Module wollen Sie belegen?',
  alerts: {
    wishlistSaveSuccess:
      'Die Wunschliste wurde erfolgreich gespeichert. Die Wunschliste kann jederzeit innerhalb des Wahlzeitraumes geändert werden',
    wishlistSaveFailed: 'Die Wunschliste konnte nicht gespeichert werden',
    signOutSuccess: 'Sie wurden erfolgreich aus dem Modul ausgetragen',
    signOutFailed: 'Beim austragen aus dem Modul ist ein Fehler aufgetreten'
  }
};

export default de;
export type StudentViewTranslation = typeof de;
